<div class="auth-wrapper">
  <div class="auth-wrapper-inner">
    <div class="auth-wrapper-image relative">
      <div class="">
        <img
          class="auth-background object-cover"
          src="assets/auth/login-image.png"
        />
      </div>

      <!-- Dark overlay for better text readability -->
      <div class="absolute inset-0 bg-gray-700/20 z-20"></div>

      <div
        class="auth-caption absolute top-0 left-0 right-0 px-10 max-w-md translate-y-1/2 z-30 grid gap-4"
      >
        <h1
          class="text-5xl font-bold leading-[80px] bg-gradient-to-br to-sky-600 from-sky-400 bg-clip-text text-transparent"
        >
          QUẢN LÝ KYNP Booking Hotel
        </h1>
        <p class="text-2xl font-bold text-white">NHANH CHÓNG TIỆN LỢI</p>
      </div>
    </div>
    <div class="auth-wrapper-form">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
